<template>
	<div>
		<div class="circle">
			<div class="circle-nav">
				<!--<div class="circle-nav-search"></div>-->
				<div class="circle-nav-item" @click="switchNav($event,'hot')">热门</div>
				<div class="circle-nav-item" @click="switchNav($event,'follow')">关注</div>
				<div class="circle-nav-item" @click="switchNav($event,'latest')">最新</div>
			</div>
			<ul class="circle-items f-cbli" v-dt-infinite-scroll="getData" :change-sign="changeSign">
				<!--<li class="circle-item">
					<div class="circle-avatar f-img-box">
						<img src="../index/teacher.png">
					</div>
					<div class="circle-content">
						<div class="circle-name f-cb">
							<div class="circle-name-text">会哭的蒲公英</div>
							<div class="circle-name-follow">关注</div>
						</div>
						<div class="circle-quote">
							<div class="circle-quote-note">
								<div class="circle-quote-note-title o1">标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题</div>
								<div class="circle-quote-note-text o2">正文正文正文正文正文正文正文正文正文正文正文正文正文正文正文正文正文</div>
							</div>
							<div class="circle-quote-question">
								<div class="circle-quote-answer-ask o1">问题问题问题问题问题问题问题问题问题问题问题问题问题问题问题问题</div>
								<div class="circle-quote-answer-answer o2">问题问题问题问题问题问题问题问题问题问题问题问题问题问题问题问题</div>
							</div>
							<div class="circle-from f-cb">
								<div class="circle-from-pic f-img-box">
									<img src="../index/banner.jpg">
								</div>
								<div class="circle-from-content">
									<div class="circle-from-title o2">标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题</div>
									<div class="circle-from-info">
										<div class="circle-from-num">1200人观看</div>
										<div class="circle-from-star"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="circle-info f-cb">
							<div class="circle-info-time">2018.8.15</div>
							<div class="circle-info-comment">3</div>
							<div class="circle-info-fav">234</div>
						</div>
						<div class="circle-comment">
							<ul class="circle-comment-items">
								<li class="circle-comment-item"><span>刘翔</span>说得很好</li>
								<li class="circle-comment-item"><span>刘翔</span>回复范冰冰：说得很好</li>
							</ul>
							<div class="circle-comment-all">查看全部评论<img src="./all.png"></div>
						</div>
					</div>
				</li>-->
				<li class="circle-item" v-for="(item,index) in data">
					<div class="circle-avatar f-img-box" @click="$router.push('/other/history/'+item.user_id)">
						<img :src="item.avatar?item.avatar:studentAvatar">
					</div>
					<div class="circle-content">
						<div class="circle-name f-cb">
							<div class="circle-name-text" @click="$router.push('/other/history/'+item.user_id)">{{item.nick_name}}</div>
							<div class="circle-name-follow" v-if="item.user_id!=userId" @click="switchFollow(index)" :class="{'circle-name-follow-active':item.is_follow}">{{item.is_follow?"已关注":"关注"}}</div>
						</div>
						<div class="circle-quote">
							<div class="circle-quote-note" v-if="item.type==1" @click="$router.push('/note/'+item.id)">
								<div class="circle-quote-note-title o1">{{item.title}}</div>
								<div class="circle-quote-note-text" v-html="item.content"></div>
							</div>
							<div class="circle-quote-question" v-else @click="$router.push('/answer/'+item.id)">
								<div class="circle-quote-answer-ask o1">{{item.title}}</div>
								<div class="circle-quote-answer-answer o2" v-if="item.answer.length>0">{{item.answer[0].content}}</div>
							</div>
							<div class="circle-from f-cb" v-if="item.course_info[0]" @click="$router.push('/lesson-detail/'+item.course_info[0].id)">
								<div class="circle-from-pic f-img-box">
									<img :src="item.course_info[0].cover_img">
								</div>
								<div class="circle-from-content">
									<div class="circle-from-title o2">{{item.course_info[0].course_title}}</div>
									<div class="circle-from-info">
										<div class="circle-from-num">{{item.course_info[0].play_num}}人观看</div>
										<div class="circle-from-star"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="circle-info f-cb">
							<div class="circle-info-time">{{tools.timestampConversion(item.create_time)}}</div>
							<div class="circle-info-comment">{{item.type==1?item.replies.length:""}}</div>
							<div class="circle-info-fav" @click="addFav(index,item.type==1?'note':'question')" :class="{'circle-info-fav-active':item.is_like}">{{item.like_num}}</div>
						</div>
						<div class="circle-comment" v-if="item.replies && item.replies.length>0">
							<ul class="circle-comment-items">
								<!--<li class="circle-comment-item"><span>刘翔</span>回复范冰冰：说得很好</li>-->
								<li class="circle-comment-item" v-for="value in item.replies"><span v-if="value.reply_userinfo" @click="$router.push('/other/history/'+value.reply_userinfo.id)">{{value.reply_userinfo.nick_name}}</span>{{value.content}}</li>
							</ul>
							<div class="circle-comment-all" v-if="item.replies.length>2" @click="expandReply($event)">查看全部评论<img src="./all.png"></div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[],
				type:"", //type:follow关注 hot热门 latest最新
				changeSign:false,
        userId:this.tools.getCookie("mooc_user_id")
			}
		},
		mounted(){
			var type=this.$route.params.type;
			this.type=type;
			if(type)
				this.addActive(type);
		},
		methods:{
			switchNav(e,name){
				this.$router.replace("/circle/"+name);
			},
			addActive(path){
				var domList=document.querySelectorAll(".circle-nav-item");
				domList.forEach((domValue)=>{
					if(domValue.className.indexOf("circle-nav-item-active")!=-1){
						domValue.className=domValue.className.replace("circle-nav-item-active","");
					}
				});
				["hot","follow","latest"].forEach((value,index)=>{
					if(path.indexOf(value)!=-1){//此处应该改成用正则检测circle/后面，下一个/前面的字符是否匹配
						domList[index].className+=" circle-nav-item-active";
					}
				});
			},
			getData(page){
				var len=10;
				var type=this.type;
				return new Promise((resolve,reject)=>{
					var handleData=(data)=>{
						this.data=this.data.concat(data);
						if(data.length<10){
							reject();
						}
						else{
							resolve();
						}
					}
					if(type=="follow"){
						this.$api.get("",{
							api:"/v1/circle/getFocususers",
							user_type:this.tools.getCookie("user_type"),
							len:10,
							page
						},res=>{
							handleData(res.data);
						})
					}
					else{
						switch(type){
							case "hot":
								type=2;
								break;
							case "latest":
								type=0;
								break;
						}
						this.$api.get("",{
							api:"/v1/Circle/index",
							user_type:this.tools.getCookie("user_type"),
							len:10,
							page,
							order:type
						},res=>{
							handleData(res.data);
						})
					}
				})
			},
			expandReply(e){
				var target=e.target;
				target.previousSibling.previousSibling.style.maxHeight="none";
				target.style.display="none";
			},
			switchFollow(index){
				var data=this.data[index];
				if(!data.is_follow){
					this.$api.get("",{
						api:"/v1/follow/followById",
						follow_id:data.user_id,
						user_type:this.tools.getCookie("user_type")
					},res=>{
						this.data[index].is_follow=1;
					})
				}
				else{
					this.$api.get("",{
						api:"/v1/follow/unfollowById",
						follow_id:data.user_id,
						user_type:this.tools.getCookie("user_type")
					},res=>{
						this.data[index].is_follow=0;
					})
				}
			},
			addFav(index,type){
				var data=this.data[index];
				var success=res=>{
					this.data[index].is_like=1;
					this.data[index].like_num+=1;
					this.$toast("点赞成功");
				}
				if(type=="note"){
					this.$api.get("",{
						api:"/v1/section_note/addLike",
						id:data.id,
						user_type:this.tools.getCookie("user_type")
					},success)
				}
				else{
					this.$api.get("",{
						api:"/v1/question_answer/addLike",
						id:data.id,
						user_type:this.tools.getCookie("uesr_type")
					},success)
				}
			}
		},
		watch:{
			$route(){
				var type=this.$route.params.type;
				this.type=type;
				this.data=[];
				this.addActive(type);
				this.changeSign=!this.changeSign;
			}
		}
	}
</script>

<style>
	.circle-nav{
		font-size: 0;
		text-align: center;
		background: #fff;
	}
	.circle-nav-search{
		float:right;
		margin-right: 0.4rem;
		width:0.5rem;
		height:1.146rem;
		background: url(../search/search.png) center center no-repeat;
		background-size: 0.48rem;
	}
	.circle-nav-item{
		display: inline-block;
		width:2rem;
		height:1.146rem;
		border-bottom:2px solid #fff;
		line-height: 1.146rem;
		text-align: center;
		color:#333;
		font-size: 0.4rem;
	}
	.circle-nav-item-active{
		border-color: #ec6d3a;
		color:#ec6d3a;
		font-weight: bold;
	}
	.circle-items{
		padding:0 0.4rem;
	}
	.circle-item{
		padding-top:0.533rem;
		padding-bottom: 0.533rem;
		border-bottom: 1px solid #e0e0e0;
	}
	.circle-avatar{
		float:left;
		overflow: hidden;
		width:1.2rem;
		height:1.2rem;
		border-radius: 50%;
	}
	.circle-content{
		float:right;
		width:7.6rem;
	}
	.circle-name{
		margin-top:0.306rem;
	}
	.circle-name-text{
		float:left;
		height:0.586rem;
		line-height:0.586rem;
		color:#333;
		font-size:0.426rem;
	}
	.circle-name-follow{
		float:right;
		width:1.506rem;
		height:0.586rem;
		text-align: center;
		font-size: 0.373rem;
		background:#EC6D3A;
		line-height:0.586rem;
		color:#fff;
		border-radius: 0.133rem;
	}
	.circle-name-follow-active{
		background:#ccc;
		color:#fff;
	}
	.circle-quote{
		margin-top:0.306rem;
		padding:0.4rem;
		background: #eee;
		border-radius: 0.133rem;
	}
	.circle-quote-note{
		padding-bottom:0.2rem;
	}
	.circle-quote-note-title{
		font-size: 0.453rem;
		color:#333;
	}
	.circle-quote-note-text{
		overflow: hidden;
		margin-top:0.24rem;
		height:1.04rem;
		font-size: 0.346rem;
		line-height:0.52rem;
	}
	.circle-quote-answer{
		padding-bottom:0.2rem;
	}
	.circle-quote-answer-ask{
		padding-left:0.586rem;
		font-size: 0.453rem;
		line-height:0.68rem;
		background: url(../lesson-question/ask.png) center left no-repeat;
		background-size: 0.426rem;
	}
	.circle-quote-answer-answer{
		margin-top:0.133rem;
		padding-left:0.586rem;
		background: url(../lesson-question/answer.png) left 0.053rem no-repeat;
		background-size: 0.426rem;
		font-size: 0.346rem;
		color:#666;
		line-height:0.52rem;
	}
	.circle-from{
		padding-top:0.266rem;
		border-top:1px solid #e6e6e6;
	}
	.circle-from-pic{
		float:left;
		overflow: hidden;
		width:2.773rem;
		height:1.786rem;
		border-radius: 0.133rem;
	}
	.circle-from-content{
		float:right;
		width:3.933rem;
	}
	.circle-from-title{
		font-size: 0.426rem;
		line-height:0.56rem;
	}
	.circle-from-info{
		margin-top:0.4rem;
	}
	.circle-from-num{
		float:left;
		font-size: 0.32rem;
		color:#999;
	}
	.circle-info{
		margin-top:0.373rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.circle-info-time{
		float:left;
		width:3.493rem;
	}
	.circle-info-comment{
		float:left;
		padding-left:0.466rem;
		background:url(./comment.png) center left no-repeat;
		background-size:0.32rem;
	}
	.circle-info-fav{
		float:right;
		padding-left:0.44rem;
		background: url(../lesson-evaluate/fav.png) center left no-repeat;
		background-size:0.32rem;
	}
	.circle-info-fav-active{
		background-image:url(../lesson-evaluate/fav-active.png);
		color:#ff3939;
	}
	.circle-comment{
		margin-top:0.4rem;
		padding:0.36rem 0.4rem 0.4rem 0.4rem;
		background:#eee;
		border-radius: 0.133rem;
	}
	.circle-comment-items{
		overflow: hidden;
		max-height:1.226rem;
	}
	.circle-comment-item{
		margin-top:0.04rem;
		color:#666;
		font-size: 0.346rem;
		line-height:0.613rem;
	}
	.circle-comment-item span{
		margin-right:0.16rem;
		color:#3192E0;
	}
	.circle-comment-all{
		margin-top:0.226rem;
		text-align: center;
		color:#999;
	}
	.circle-comment-all img{
		margin-left:0.2rem;
		width:0.293rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/circle/circle.vue